module.exports = __webpack_public_path__ + "img/slide1.7989eeae.jpg";